'use strict';
import $ from 'jquery';

export default class CustomPostsLoop {
    static init() {
        $('.module-custom-posts-loop').each((index, el) => {
            new CustomPostsLoop($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        this.featuredPostsSlider();
    }

    featuredPostsSlider() {
        const $featured = this.el.find('.section-custom-posts-loop-featured');
        if (!$featured.hasClass('slick-initialized')) {
            $featured.slick({
                mobileFirst: true,
                dots: true,
                arrows: false,
                adaptiveHeight: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4
                        }
                    }
                ]
            });
        }
    }
}